<template lang="pug">
UiModal(
  :show="show"
  @close="close"
  :title="$t('admin_users.import_title')"
  :subtitle="$t('admin_users.import_description')"
  :rightActions="rightActions"
)
  p
    a(
      href="/import_users_example.xlsx"
      target="_blank"
    ) {{ $t("companies.file_example") }}

  UiFilePicker(
    v-model="file"
    placeholder="Choose a file or drop it here..."
    :extensions="['xlsx']"
  )
</template>

<script>
import ApiAdminCompanyUsers from "@/api/admin_company_users.js";

export default {
  $_veeValidate: {
    validator: "new",
  },

  data() {
    return {
      show: false,
      file: null,
    };
  },

  computed: {
    rightActions() {
      return [
        {
          label: this.$t("actions.upload"),
          icon: "FileUpload",
          disabled: !this.file,
          onClick: this.upload,
        },
      ];
    },
  },

  methods: {
    open() {
      this.show = true;
    },

    close() {
      this.show = false;
    },

    upload() {
      let formData = new FormData();
      formData.append("file", this.file);
      ApiAdminCompanyUsers.importUsers(formData)
        .then((resp) => {
          this.$emit("done");
          this.close();
        })
        .catch((e) => {});
    },
  },
};
</script>
